<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import { uuid } from "vue-uuid";

export default {
  mixins: [Api, Sabit],
  props: [
    "Raporgirisid",
    "Kontrolgirisid",
    "Icdegergirisid",
    "OnayDurumu",
    "Odenekid",
  ],
  data() {
    return {
      file: "",
      uzanti: "",
      files: [],
      fileInputs: [],
      uuid: uuid.v4(),

      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Filter: "",
      TabloVerileri: [],
      TabloDetayVerileri: [],
      AddEdit: "Add",
      FilenameEdit: "",
      FilenameEditIndex: null,
      FormVeri: {
        Fileurl: "",
        Deleted: false,
        Filename: "",
        Link: "",
        Kontrolgirisid: "",
        Raporgirisid: "",
        IcDegerId: "",
        Odenekid: "",
      },
    };
  },

  computed: {},
  watch: {
    Kontrolgirisid() {
      this.Get();
    },

    Raporgirisid() {
      this.Get();
    },
    Odenekid() {
      this.Get();
    },
    Icdegergirisid() {
      this.Get();
    },
  },

  methods: {
    Get() {

      this.TabloDetayVerileri = [];


      if (
        this.Raporgirisid != null &&
        this.Raporgirisid != "00000000-0000-0000-0000-000000000000"
      ) {

        this.Filter = "&Raporgirisid=" + this.Raporgirisid;
        this.FormVeri.Raporgirisid = this.Raporgirisid;
      } else if (
        this.Kontrolgirisid != null &&
        this.Kontrolgirisid != "00000000-0000-0000-0000-000000000000"
      ) {

        this.Filter = "&Kontrolgirisid=" + this.Kontrolgirisid;
        this.FormVeri.Kontrolgirisid = this.Kontrolgirisid;
      } else if (
        this.Icdegergirisid != null &&
        this.Icdegergirisid != "00000000-0000-0000-0000-000000000000"
      ) {
        this.Filter = "&IcDegerId=" + this.Icdegergirisid;
        this.FormVeri.IcDegerId = this.Icdegergirisid;
      }
       else if (
          this.Odenekid != null &&
        this.Odenekid != "00000000-0000-0000-0000-000000000000"
      ) {
            this.Filter = "&Odenekid=" + this.Odenekid;
        this.FormVeri.Odenekid = this.Odenekid;
      } else {
        this.Filter = "";
      }

      if (this.Filter != "" && this.Filter != null) {

        this.ActionsFilterGet({
          Service: "StrKontrolGirisKanit",
          Page: this.Page,
          Filter: this.Filter,
        }).then((res) => {
          this.TabloDetayVerileri = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        });
      }
    },
    onSubmit() {},
    FileUpload() {
      this.files = Array.from(this.$refs.file.files);
      this.fileInputs = this.files.map(f => ({
        file: f,
        customName: f.name, 
      }));
    },
async submitFile() {
  if (this.fileInputs.length > 0) {
    for (const { file, customName } of this.fileInputs) {
      const uzanti = file.name.split(".").pop().toLowerCase();

      if (
        ["pdf", "png", "jpeg", "jpg", "xls", "xlsx", "doc", "docx"].includes(uzanti)
      ) {
        const formData = new FormData();
        formData.append("file", file);

        try {
          const res = await this.Post(
            "GenericFileUpDownload/UploadFile?pathUrl=Str",
            formData
          );

          if (res) {
            const newForm = {
              ...this.FormVeri,
              Fileurl: "Str/" + res.Data.filename,
              Filename: customName, 
            };
            await this.submit_veri(newForm);
          }
        } catch (err) {
          this.$toast.error(file.name + " yüklenirken hata oluştu");
        }
      } else {
        this.$toast.error(file.name + " geçersiz dosya türü");
      }
    }


    this.fileInputs = [];
    this.files = [];
    this.FormVeri.Filename = "";
    this.FormVeri.Fileurl = "";
    this.FormVeri.Link = "";
    this.$refs.file.value = "";
  } else if (this.FormVeri.Link) {
    this.submit_veri(this.FormVeri);
  } else {
    this.$toast.error(this.$t("StrKontrolGirisKanit.Alerts.validate"));
  }
},

    submit_veri(FormDataParam = this.FormVeri) {
      const veri = { ...FormDataParam };

      if (this.Kontrolgirisid != null) {
        delete veri.Raporgirisid;
        delete veri.IcDegerId;
        delete veri.Odenekid;
      }
      if (this.Raporgirisid != null) {
        delete veri.Kontrolgirisid;
        delete veri.IcDegerId;
        delete veri.Odenekid;
      }
      if (this.Odenekid != null) {
        delete veri.Kontrolgirisid;
        delete veri.IcDegerId;
        delete veri.Raporgirisid;
      }
      if (this.Icdegergirisid != null) {
        delete veri.Raporgirisid;
        delete veri.Kontrolgirisid;
        delete veri.Odenekid;
      }
      if (veri.Link) {
        veri.Filename = "link";
      }

      return this.Post("StrKontrolGirisKanit", veri).then((res) => {
        if (res) {
          this.$emit("TableUpdate");
        }
      });
    },
    indir(file, filename) {
      let dosya_adi = file.substr(4, file.length - 4);
      let uzanti = file.substr(file.lastIndexOf(".") + 1);
      let Filter = "?fileName=" + dosya_adi + "&pathUrl=Str";

      this.ActionsFileGet({
        Service: "GenericFileUpDownload/DownloadFile",
        Filter,
      }).then((res) => {
        if (res) {
          /*
           var FILE = window.URL.createObjectURL(new Blob([res.Data]));
           
           var docUrl = document.createElement('x');
           docUrl.href = FILE;
           docUrl.setAttribute('download', 'file1.pdf');
           document.body.appendChild(docUrl);
           docUrl.click();
           */

          let blob = new Blob([res]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          if (filename == "") {
            link.download = dosya_adi;
            link.click();
          } else {
            link.download = filename + "." + uzanti;
            link.click();
          }
        }
      });
    },
    KanitDelete(servis, id) {
      this.Delete(servis, id).then((res) => {
        if (res) {
          this.$emit("TableUpdate");
        }
      });
    },
    KanitEdit(Data, index) {
      this.FilenameEdit = Data.Filename;
      this.FilenameEditIndex = index;
    },
    SaveNewKanitName(Data) {
      let FormUpdateData = Data;
      FormUpdateData.Filename = this.FilenameEdit;
      this.Update("StrKontrolGirisKanit", FormUpdateData).then((res) => {
        if (res) {
          this.$emit("TableUpdate");
          this.FormVeri.Filename = "";
          this.FormVeri.Fileurl = "";
          this.FormVeri.Link = "";
          this.FilenameEdit = "";
          this.FilenameEditIndex = null;
          this.file = "";
        }
      });
    },
  },
};
</script>
<template>
  <b-modal
    id="StrKontrolGirisKanit"
    size="xl"
    :title="$t('StrKontrolGirisKanit.AddEdit.FormTitle')"
    title-class="font-18"
    hide-footer
  >
    <Form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-md-10">
          <div class="mt-3" v-if="!OnayDurumu">
          <input
            class="form-control"
            ref="file"
            name="sefer"
            type="file"
            multiple
            @change="FileUpload($event)"
            id="file"
            accept=".jpg, .jpeg, .png, .pdf, .xls, .xlsx, .doc, .docx "
          />

          </div>
<div v-if="fileInputs.length > 0" class="mt-4">

  <div
    v-for="(f, i) in fileInputs"
    :key="i"
    class="row align-items-center mb-2"
  >
    <div class="col-6">
<span class="fw-bold" :title="f.file.name">
  {{ f.file.name.length > 70 ? f.file.name.substring(0, 70) + '...' : f.file.name }}
</span>

    </div>
    <div class="col-6">
      <b-form-input
        v-model="f.customName"
        placeholder="Kaydedilecek dosya ismi"
      />
    </div>
  </div>
</div>




          <b-form-group
            v-if="!OnayDurumu && Icdegergirisid == null"
            class="d-block"
            id="example text"
            label-cols-lg="4"
            label="Link"
            label-for="text"
          >
            <div class="col-sm-auto">
              <label for="inlineFormemail2" class="sr-only">Email</label>
              <div role="group" class="input-group mb-3">
                <!--    <div class="input-group-prepend">
                  <div class="input-group-text">http://</div>
                </div> -->
                <b-form-input
                  for="text"
                  v-model="FormVeri.Link"
                  value=""
                ></b-form-input>
              </div>
            </div>
          </b-form-group>
        </div>
      </div>

      <br />

      <button
        v-if="!OnayDurumu"
        class="btn btn-primary"
        v-on:click="submitFile()"
      >
        {{ $t("StrKontrolGirisKanit.AddEdit.Button") }}
      </button>
    </Form>
    <hr />

    <div class="table-responsive">
      <table class="table table-striped table-bordered mb-0">
        <tbody>
          <tr>
            <th scope="col">{{ $t("StrKontrolGirisKanit.Table.KanitAdi") }}</th>

            <th scope="col"></th>
            <th scope="col">{{ $t("StrKontrolGirisKanit.Table.Islem") }}</th>
          </tr>
          <tr v-for="(Data, index) in TabloDetayVerileri" :key="index">
            <td class="d-flex">
              <div v-if="Data.Fileurl != '' && Data.Link == ''">
                {{ Data.Filename }}
              </div>
              <div v-if="Data.Link != '' && Data.Fileurl == ''">
                <a :href="Data.Link" target="blank">{{ Data.Link }}</a>
              </div>
              <div v-if="Data.Link != '' && Data.Fileurl != ''">
                {{ Data.Filename }} <br />
                <a :href="Data.Link" target="blank">{{ Data.Link }}</a>
              </div>
              <div
                scope="col"
                v-if="index == FilenameEditIndex && Data.Link == ''"
                style="width: 100%;"
              >
                <b-form-input
                  for="text"
                  v-model="FilenameEdit"
                  value=""
                ></b-form-input>
              </div>
            </td>
            <td>
              <div v-if="Data.Fileurl != ''">
                <i
                  style="margin-left:10px"
                  @click="indir(Data.Fileurl, Data.Filename)"
                  class="fas fa-download"
                >
                </i>
              </div>
            </td>
            <td>
              <i
                style="margin-left:10px"
                @click="KanitEdit(Data, index)"
                class="fas fa-pen"
                v-if="Data.Link == ''"
              >
              </i>
              <i
                style="margin-left:10px"
                @click="SaveNewKanitName(Data, index)"
                class="fas fa-save"
                v-if="
                  FilenameEditIndex != null &&
                    FilenameEditIndex == index &&
                    Data.Link == ''
                "
              >
              </i>
              <i
                style="margin-left:10px"
                @click="KanitDelete('StrKontrolGirisKanit', Data.Id)"
                class="fas fa-trash-alt"
              >
              </i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>
